import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';
import { applyColor } from '~src/style/ColorService';

const cssPrefix = 'ModelSettingsSection';
export namespace ModelSettingsSectionStyles {

    export const sectionLabel = cssClass(cssPrefix, 'section-label', {
        marginTop: TabStyles.Spacing.ExtraLargeSpace
    });

    export const modelsContainer = cssClass(cssPrefix, 'models-container', {
        marginTop: TabStyles.Spacing.MediumSpace
    });

    const modelsListBaseStyle = {
        listStyleType: 'disc' as const,
        paddingLeft: TabStyles.Spacing.LargeSpace
    };

    export const modelsList = cssClass(cssPrefix, 'models-list', {
        ...modelsListBaseStyle
    });

    export const modelsListDisabled = cssClass(cssPrefix, 'models-list-disabled', {
        ...modelsListBaseStyle,
        color: applyColor(DesignTokens.color.font.default.disabled, TabStyles.Typography.Color.Disabled)
    });

    export const alertContainer = cssClass(cssPrefix, 'alert-container', {
        marginBottom: TabStyles.Spacing.LargeSpace,
        marginTop: TabStyles.Spacing.LargeSpace,
        display: 'flex',
        flexDirection: 'column',
        gap: TabStyles.Spacing.MediumSpace
    });

}
